<div class="container">
  <div class="title">
    Choose prompt
  </div>
  <div class="close-button" (click)="closePopup()">
    <i class="bi bi-x"></i>
  </div>
  <div class="prompt-list">
    @for (prompt of prompts; track prompt) {
      <div class="prompt-item" (click)="selectPrompt(prompt)">
        {{prompt}}
      </div>
    }
  </div>
</div>